'use strict';

var teasersModules = require('./teaser/teasersModules');

/* Javascript to load on page load*/
$(document).ready(function () {
	// PDP teasers only
    if ($('span.product-id').text().length) {
        teasersModules.loadTeaserCounts(turnToProductSku);
    }

    // Set session storage when clicking on stars below product name
    $('body').on('click', '#product-name-review', function (e) {
        e.preventDefault();
        window.sessionStorage.setItem('reviewsStarsBelowProductName', 'true');
        // Manually open the modal after setting the flag
        var modalId = $(this).data('modal');
        $('#' + modalId).modal('show');
    });
});
